import DataTableV2ItemEdit from '@/agilis/components/DataTableV2/DataTableV2ItemEdit/DataTableV2ItemEdit.js'
import { mapActions } from 'vuex'

export default {
  name: 'ContactTableItemEdit',
  mixins: [DataTableV2ItemEdit],

  methods: {
    ...mapActions({
      'notifyUserConfirm': 'notificationStore/notifyUserConfirm'
    }),

    async saveItem (itemDTO) {
      await this.notifyUserConfirm({
        title: this.$t('sales.label.legacyContactWarningTitle'),
        messages: this.$t('sales.label.legacyContactWarningMessage'),
        confirm: 'OK',
        hideCancel: true
      })

      DataTableV2ItemEdit.methods.saveItem.call(this, itemDTO)
    }
  }
}
